import styled, { css, keyframes } from 'styled-components'

export const Wrapper = styled.div`
  height: 100vh;
  position: relative;
  overflow: hidden;
  padding: 100px 0;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 36px;
`

export const Phrase = styled.h2<{ isVisible: boolean }>`
  text-align: center;
  font-size: 2.5rem;
  font-weight: 700;
  color: #000d6d;
  margin: 0;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transform: ${({ isVisible }) => (isVisible ? 'scale(1.1)' : 'scale(0.8)')};
  transition: all 0.8s ease;
  @media (max-width: 850px) {
    font-size: 1.8rem;
  }
  @media (max-width: 450px) {
    font-size: 1.3rem;
  }
  @media (max-width: 350px) {
    width: 300px;
    font-size: 1.5rem;
  }
`

export const Logo = styled.img`
  background-color: #f4f4fc;
  border-radius: 102.375px;
  padding: 15px;
  width: 200px;
  height: 100px;
  object-fit: contain;
`
const scrollLeft = keyframes`
  0% { transform: translateX(50%); }
  100% { transform: translateX(-50%); }
`

const scrollRight = keyframes`
  0% { transform: translateX(-50%); }
  100% { transform: translateX(50%); }
`

export const LogosRow = styled.div<{
  direction: 'left' | 'right'
  animate: boolean
  paused: boolean
}>`
  display: flex;
  width: fit-content;
  gap: 2rem;
  overflow: hidden;
  white-space: nowrap;
  will-change: transform;

  ${({ animate, direction, paused }) =>
    animate &&
    css`
      animation: ${direction === 'left' ? scrollLeft : scrollRight} 20s linear infinite;
      animation-play-state: ${paused ? 'paused' : 'running'};
    `}
`
